import { ref, computed } from 'vue'
import { defineStore } from 'pinia';
import { setSecureCookie } from '@/helpers/cookies';

export const useSearchSpringCookiesStore = defineStore('searchSpringCookies', ()=>{
    const SEVEN_YEARS_DAYS = 7 * 365;

    let ssViewedProducts = computed({
        get(){
            if(typeof document === 'undefined'){
                return [];
            }
            let products = document.cookie
                    .split("; ")
                    .find((row) => row.startsWith("ssViewedProducts=")) ?? "ssViewedProducts=";
            return products.split('=')[1].split(',');
        },
        set(newVal){
            if(typeof document === 'undefined'){
                return;
            }
            newVal = newVal?.split(',').filter(prod => prod != '') ?? [];
            if(newVal.length == 0){
                setSecureCookie('ssViewedProducts', '', { expires: new Date(0) });
            }else{
                setSecureCookie('ssViewedProducts', newVal.join(','), { expires: SEVEN_YEARS_DAYS });
            }
        }
    })

    let ssCartProducts = computed({
        get(){
            if(typeof document === 'undefined'){
                return [];
            }
            let products = document.cookie
                    .split("; ")
                    .find((row) => row.startsWith("ssCartProducts=")) ?? "ssCartProducts=";
            return products.split('=')[1].split(',');
        },
        set(newVal){
            if(typeof document === 'undefined'){
                return;
            }
            newVal = newVal?.split?.(',').filter?.(prod => prod != '') ?? [];
            if(newVal.length == 0){
                setSecureCookie('ssCartProducts', '', { expires: new Date(0) });
            }else{
                setSecureCookie('ssCartProducts', newVal.join(','), { expires: SEVEN_YEARS_DAYS });
            }
        }
    })

    function addViewedProduct(productId: string){
        let viewedProducts = ssViewedProducts.value;
        if(viewedProducts.includes(productId)){
            return;
        }
        if(viewedProducts.length >= 5){
            viewedProducts.pop();
        }
        viewedProducts.unshift(productId);
        ssViewedProducts.value = viewedProducts.filter(prod => prod != '').join(',');
    }

    function addCartProduct(productId: string){
        let cartProducts = ssCartProducts.value;
        if(cartProducts.includes(productId)){
            return;
        }
        cartProducts.push(productId);
        ssCartProducts.value = cartProducts.filter(prod => prod != '').join(',');
    }
    function clearCartProduct(productId: string){
        let cartProducts = ssCartProducts.value;
        cartProducts = cartProducts.filter(prod => prod != productId);
        ssCartProducts.value = cartProducts.filter(prod => prod != '').join(',');
    }
    
    function clearCartProducts(){
        ssCartProducts.value = [];
        ssCartProducts.value = '';
    }

    function addCartProducts(productIds: string[]){
        let cartProducts = ssCartProducts.value;
        productIds.forEach((productId)=>{
            if(cartProducts.includes(productId)){
                return;
            }
            cartProducts.push(productId);
        });
        ssCartProducts.value = cartProducts.filter(prod => prod != '').join(',');
    }
    
    return {
        ssViewedProducts,
        ssCartProducts,
        addViewedProduct,
        addCartProduct,
        addCartProducts,
        clearCartProduct,
        clearCartProducts
    }
});